import Link from 'next/link';
import Checkbox from 'components/Checkbox';
import Button from 'components/Button';
import DoubleChevronRight from 'svg/double-chevron-right.svg';
import Fieldset from 'components/Fieldset';
import { useTranslation, Trans } from 'next-i18next';

function LinkText({ href, children }) {
  return (
    <Link href={href} legacyBehavior>
      {children[0]}
    </Link>
  );
}

const PrivacyPolicyForm = ({
  disabled,
  saving,
  onInputChange,
  inputs,
  onSubmit,
  submitLabel,
  submitDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <Fieldset title={t('privacyPolicy.label')} disabled={saving || disabled}>
      <Checkbox
        test="acceptedPrivacyTerms"
        label={
          <Trans
            i18nKey="acceptPrivacyPolicy.label"
            t={t}
            components={[<LinkText href="/privacy" />]}
          />
        }
        name="acceptedPrivacyTerms"
        id="acceptedPrivacyTerms"
        onChange={onInputChange}
        checked={inputs.acceptedPrivacyTerms}
        required
      />
      <Button
        test="submitVacancy"
        type="submit"
        onClick={onSubmit}
        label={submitLabel}
        extraClasses="c-button--chevron u-margin-top-base"
        Icon={DoubleChevronRight}
        disabled={submitDisabled}
      />
    </Fieldset>
  );
};

export default PrivacyPolicyForm;
